import React from 'react';
import { withTranslation } from 'react-i18next';
import classnames from 'classnames';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import IconButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenu';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import s from './ItemControlButtons.scss';
export class ItemControlButtons extends React.Component {
    render() {
        const { t, menuItems, withOneClickDelete, moreMenuClassName, onDelete } = this.props;
        return /*#__PURE__*/ React.createElement("div", {
            onClick: this.onClick,
            className: classnames(s['root'], this.props.className)
        }, withOneClickDelete && /*#__PURE__*/ React.createElement(IconButton, {
            tooltipText: t('mediapopup.delete'),
            "aria-label": t('mediapopup.delete'),
            icon: TrashcanIcon,
            size: "small",
            className: s['custom-icon-button-size'],
            onClick: onDelete
        }), menuItems && /*#__PURE__*/ React.createElement(IconButtonWithContextMenu, {
            standardMenuProps: {
                className: moreMenuClassName
            },
            items: menuItems,
            icon: EllipsisIcon,
            "aria-label": t('common.more'),
            className: s['custom-icon-button-size'],
            size: "small"
        }));
    }
    onClick(event) {
        event.stopPropagation();
    }
}
export default withTranslation()(ItemControlButtons);

//# sourceMappingURL=ItemControlButtons.js.map